import {
	createPageSegmentLoadMetric,
	END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY,
} from '@confluence/browser-metrics';

export const END_OF_PAGE_RECOMMENDATIONS_METRIC = createPageSegmentLoadMetric({
	key: END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY,
});
